<template lang="pug">
.acr
  .pageHeader
    .pageName 縣市填報
  .acr_body
    .acr_no_cards(v-if="activity_results_data == null ||  activity_results_data.length === 0") 目前無任何填報
    el-table(v-else :data="activity_results_data")
      el-table-column(label="要填報的標題" prop="title")
      el-table-column(label="填寫連結如下：")
        template(slot-scope="scope")
          .link_button(@click="go_to_apply(scope.row.id)") 填寫
  .acr_pageList
</template>

<script>
import { fetchApplicationFormList } from '@/api/client/ApplicationForm'
export default {
  data() {
    return {
      activity_results_data: null
    }
  },
  created() {
    this.get_results_activity(1);
  },
  async mounted (){
    const user = sessionStorage.getItem('user3')  //如果沒登入則回到登入頁面
    //console.log(user)
    if (!user) {
      //this.$router.push({ name: 'UploadData'})
      this.$router.push({ path: '/activity/loginNow2' })
      return
    }
    const { u_str } = JSON.parse(user)
    this.u_str = u_str
    console.log("UserID:"+this.u_str)

    if (!u_str) {
      //this.$router.push({ name: 'UploadData' })
     // this.$router.push({ path: '/artedu1872/class/loginNow' })
      return
    }
    //取得user id
    await this.fetchDataList(u_str)
  },
  methods: {
    // 拿到縣市填報的報名表
   async  get_results_activity(page) {
      const { data } = await fetchApplicationFormList({ page: page })
      this.activity_results_data = data
    },
    // 連結縣市填報
    go_to_apply(id) {
      const { href } = this.$router.resolve({
        name: 'applicationForm',
        params: { formId: id }
      })
      window.open(href, '_blank')
    }
  }
}
</script>

<style lang="sass" scoped>
@import '@/assets/style.sass'

.acr
  width: 80%
  box-sizing: border-box
  margin-top: 10px
  margin-left: 10%
  // padding: 0 0 400px 0
  +pad
    width: 95%
    margin-left: 2.5%
.acr_no_cards
  font-size: 20px
  color: #999
  // font-weight: bold
  font-style: italic
  margin-top: 10px
.link_button
  border: solid 0.5px #777
  width: 40px
  padding: 2px 3px
  border-radius: 3px
  background-color: #EEE
  color: #555
  cursor: pointer
  transition: 0.3s
  text-align: center
  margin:
    top: 3px
    bottom: 3px
  &:hover
    transform: scale(1.05)
    transition: 0.3s
  &:active
    background-color: #777
    color: #fff
</style>



// WEBPACK FOOTER //
// src/views/activity_results/activity_results.vue